import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/deals/[id]/messages/Page";

export const PATH = (id: number): string => `/deals/${id}/messages`;

function DealMessage() {
	return (
		<>
			<NskHead title="施工会社とチャット" />
			<Component />
		</>
	);
}

export default DealMessage;
